<template lang="pug">
    .settings(v-if='settings')
        span(v-if="parametersFrom === 'homework'")
            | {{ $i18n.t('trainer.trainer_gameFormSetting_numOfExamples') }}:
            | {{ settings.amountOfExamples }}
            br
            template(v-if="settings.timeForAnswer != '-1'")
                | {{ $i18n.t('trainer.trainer_gameFormSetting_timeToAnswer') }}:
                | {{ settings.timeForAnswer }} {{ $i18n.t('trainer.trainer_gameFormSettingValue_seconds') }}
                br
                template(v-if='settings.numbers.length > 0')
                | {{ $i18n.t('trainer.trainer_gameFormSetting_numbers') }}: {{ settings.numbers.join(', ') }}
                br
        template(v-if='settings.numbers.length > 0')
        | {{ $i18n.t('trainer.trainer_gameFormSetting_numbers') }}: {{ settings.numbers.join(', ') }}
        br
        | {{ $i18n.t('trainer.trainer_gameFormSetting_operations') }}: {{ operations }}
        br
        template(v-if='settings.selfDivision')
            | {{ $i18n.t('trainer.trainer_gameFormSetting_selfDivision') }}: {{ $i18n.t('trainer.trainer_gameFormSettingValue_on') }}
            br
        template(v-if='settings.changingMultipliers')
            | {{ $i18n.t('trainer.trainer_gameFormSetting_changingMultipliers') }}: {{ $i18n.t('trainer.trainer_gameFormSettingValue_on') }}
            br
        slot
</template>

<script>
    import gamePreviewMixin from '../../../utils/trainer/gamePreviewMixin';
    import { camelCase } from 'lodash';

    export default {
        mixins: [gamePreviewMixin],
        props: {
            game: Object,
            parameters: Object,
            parametersFrom: {
                type: String,
                default: 'homework',
            },
            userId: Number,
        },
        computed: {
            operations() {
                const fields = [];
                for (let key in this.settings.operations) {
                    this.settings.operations[key] && fields.push(key);
                }
                return fields
                    .map(field => this.$i18n.t(`trainer.trainer_gameFormSetting_operation${this.pascalCase(field)}`))
                    .join(', ');
            },
        },
        methods: {
            pascalCase(word) {
                word = camelCase(word);
                return word.charAt(0).toUpperCase() + word.slice(1);
            },
        },
    };
</script>
